import Vue from 'vue';
import 'muse-ui/dist/muse-ui.css';
import { Form, TextField } from 'muse-ui';

Vue.use(TextField);
Vue.use(Form);